/*
Government Purpose Rights (“GPR”)
Contract No.  W911NF-14-D-0005
Contractor Name:   University of Southern California
Contractor Address:  3720 S. Flower Street, 3rd Floor, Los Angeles, CA 90089-0001
Expiration Date:  Restrictions do not expire, GPR is perpetual
Restrictions Notice/Marking: The Government's rights to use, modify, reproduce, release, perform, display, or disclose this software are restricted by paragraph (b)(2) of the Rights in Noncommercial Computer Software and Noncommercial Computer Software Documentation clause contained in the above identified contract.  No restrictions apply after the expiration date shown above. Any reproduction of the software or portions thereof marked with this legend must also reproduce the markings. (see: DFARS 252.227-7014(f)(2)) 
No Commercial Use: This software shall be used for government purposes only and shall not, without the express written permission of the party whose name appears in the restrictive legend, be used, modified, reproduced, released, performed, or displayed for any commercial purpose or disclosed to a person other than subcontractors, suppliers, or prospective subcontractors or suppliers, who require the software to submit offers for, or perform, government contracts.  Prior to disclosing the software, the Contractor shall require the persons to whom disclosure will be made to complete and sign the non-disclosure agreement at 227.7103-7.  (see DFARS 252.227-7025(b)(2))
*/
import { TopicMasteryData } from "@ictlearningsciences/pal3-core/mastery";
import { Goal, Topic } from "@ictlearningsciences/pal3-core/types";
import { useAppSelector } from "../store/hooks";

export interface UseWithMastery {
  getMasteryForGoal: (goal: Goal) => TopicMasteryData;
  getMasteryForTopic: (topic: Topic) => TopicMasteryData;
}

export function useWithMastery(): UseWithMastery {
  const { goalMastery, topicMastery } = useAppSelector(
    (state) => state.userData
  );

  function getMasteryForTopic(topic: Topic): TopicMasteryData {
    let md: TopicMasteryData = { mastery: 0, isMastered: false };
    if (topicMastery && topicMastery[topic.id]) {
      md = topicMastery[topic.id];
    }
    if (Number.isNaN(md.mastery)) {
      md = { mastery: 0, isMastered: false };
    }
    return md;
  }

  function getMasteryForGoal(goal: Goal): TopicMasteryData {
    let md: TopicMasteryData = { mastery: 0, isMastered: false };
    if (goalMastery && goalMastery[goal.id]) {
      md = goalMastery[goal.id];
    }
    if (Number.isNaN(md.mastery)) {
      md = { mastery: 0, isMastered: false };
    }
    return md;
  }

  return {
    getMasteryForTopic,
    getMasteryForGoal,
  };
}
